// src/app/services/conductor-vehiculo.service.ts
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ConductorVehiculoService {
  private apiUrl =  `${environment.apiUrl}/api/conductorvehiculo`; 

  constructor(private http: HttpClient) { }

  // Crear nuevo registro
  createConductorVehiculo(conductor_id: string, placa: string): Observable<any> {
    console.log(conductor_id);
    return this.http.post(`${this.apiUrl}`,
      {
        conductor_id,
        vehiculo_id: placa,
      },
      { withCredentials: true }
    );
  }

  // Obtener un registro por ID
  getConductorVehiculoById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Obtener todos los registros
  getAllConductorVehiculo(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}`, { withCredentials: true });
  }

  // Actualizar un registro por ID
  updateConductorVehiculo(id: number, conductor_id: number, vehiculo_id: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, { conductor_id, vehiculo_id }, { withCredentials: true });
  }

  // Eliminar un registro por ID
  deleteConductorVehiculo(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Obtener extractos (requiere token)
  getAllConductorExtractos(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/extracto`, { withCredentials: true });
  }

  // Obtener extractos con placa (requiere token)
  getAllConductosPlacaExtracto(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/placa_extracto`, { withCredentials: true });
  }

  getConductoresPorPlaca(placa: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/placa/${placa}`, { withCredentials: true });
  }
  // Obtener extractos (requiere token)
  getExtractosPorPlaca(placa: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/extracto/${placa}`, { withCredentials: true });
  }

  getExtractosPorPlacaEstados(placa: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/extracto/estados/${placa}`, { withCredentials: true });
  }
}
